import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import DepartmentValidations from 'scaleflow/validators/department';

export interface QuickAddsDepartmentSignature {
  // The arguments accepted by the component
  Args: {
    isOpen?: boolean;
    handleFormDismiss?: () => void;
    onItemSaved?: (department: any) => void;
  };
  // Any blocks yielded by the component
  Blocks: {
    default: [];
  };
  // The element to which `...attributes` is applied in the component template
  Element: null;
}

export default class QuickAddsDepartmentComponent extends Component<QuickAddsDepartmentSignature> {
  @service declare store: any;
  @service declare router: any;

  department = {
    name: '',
  };
  departmentValidations = DepartmentValidations;

  @action
  async onSubmit(changeset: any, e: Event) {
    e.preventDefault();
    try {
      await changeset.validate();
      if (changeset.isInvalid) {
        console.debug(changeset.errors);
        return;
      }
      const department = this.store.createRecord('department', {
        name: changeset.name,
      });
      await department.save();
      this.args?.onItemSaved?.(department);
      this.handleModalDismiss();
    } catch (err) {
      console.log(err);
    }
  }

  @action
  handleModalDismiss() {
    this.args?.handleFormDismiss?.();
  }
}
